<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <a-layout
        id="components-layout-demo-top-side-2"
        style="height: 100vh;overflow: hidden;"
      >
        <router-view v-if="init" />
        <nLogin
          v-show="!init"
          ref="nlogin"
          :title="loginTitle"
          grantType="password"
          :appId="pageConfig.appId"
          :serverName="host"
          :backgroundImage="pageConfig.loginBackgroundImage"
          @success="success"
          @error="error"
        ></nLogin>
      </a-layout>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { host } from "@/api/option";
import pageConfig from "@/options/pageConfig";
import { getProjectName } from "@/api/api";

export default {
  name: "App",
  data() {
    return {
      locale: zhCN,
      init: false,
      pageConfig,
      host,
      loginTitle: ""
    };
  },
  async created() {
    let res = await getProjectName();
    this.pageConfig.title = res.data.data;
    this.loginTitle = this.pageConfig.title;
    document.title = this.pageConfig.title;
    this.$store.commit("updateTitle", this.pageConfig.title);
  },
  mounted() {},
  methods: {
    success(e) {
      console.log("success", e);
      let token = e.loginInfo.access_token;
      this.$store.commit("setClientInfo", e.clientInfo);
      this.$store.commit("setProjectInfo", e.projectInfo);
      this.$store.commit("setAuthUserInfo", e.userInfo);
      this.$store.commit("getUserMenuPower", e.userPowers);
      let projectMsg = e.projectInfo?.extraInfoObj?.projectMsg;
      let isInternalUser = e.userInfo.userType === 1;
      if (projectMsg && !isInternalUser) {
        console.log(projectMsg);
        this.$confirm({
          title: "系统提示",
          content: h => {
            return h(
              "div",
              {
                domProps: {
                  innerHTML: projectMsg
                }
              },
              []
            );
          },
          okText: "确认",
          cancelText: "取消",
          onOk: this.$logout,
          onCancel: this.$logout,
          keyboard: false
        });
        return;
      }
      sessionStorage.setItem("userInfo", JSON.stringify(e.userInfo));
      sessionStorage.setItem(this.$app_id + "_yc_token", token);
      this.$store.commit("setToken", token);
      localStorage.setItem("yc_token", token);
      sessionStorage.setItem("carsn", token);
      sessionStorage.setItem("10007_yc_token", token);
      sessionStorage.setItem("10001_yc_token", token);
      sessionStorage.setItem("10011_yc_token", token);
      sessionStorage.setItem("10015_yc_token", token);

      this.$store
        .dispatch("init")
        .then(() => {
          this.init = true;
        })
        .catch(e => {
          console.log(e);
          this.init = true;
        });
    },
    error() {}
  }
};
</script>

<style lang="less">
@import "~@/less/main.less";
#nprogress .bar {
  background: #e6f7ff !important;
}

.custom-leaflet-infowindow .leaflet-popup-content,
.leaflet-popup-content-wrapper {
  background-color: #020c1c;
  margin: 0;
  border-radius: 12px;
}
.ant-pagination-item-ellipsis {
  color: white !important;
}

.double-right-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 9;
  background-color: #085e9b;
  padding: 5px;
  border-radius: 5px;
}
.double-left-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 12;
  background-color: #085e9b;
  padding: 5px;
  border-radius: 5px;
}
.el-button--text {
  display: none !important;
}
.demoTalbe .ant-pagination-item-ellipsis {
  color: rgba(0, 0, 0, 0.25) !important;
}
.demoTalbe .ant-empty-description {
  color: #ccc !important;
}

.amap-scalecontrol {
  bottom: 10px !important;
  left: 130px !important;
  background: transparent;
  color: #fff;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}
.clearfix {
  zoom: 1;
}
</style>
